import React, { useState } from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import TabPanel from "components/TabPanel";
import PageBanner from "components/PageBanner";
import SubscriptionItem from "./SubscriptionItem";
import WorkInProgressModal from "components/WorkInProgressModal";

import { routes } from "routes/routes";
import { subscriptionTabs } from "./variables";

import HomeBunnerImg from "assets/images/home-banner-img.png";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

const Subscriptions: React.FC = () => {
  const navigate = useNavigate();

  const [visibleTab, setVisibleTab] = useState<string>(subscriptionTabs[0].id);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openModal = () => {
    setIsContactModalOpen(true);
  };

  const closeModal = () => {
    setIsContactModalOpen(false);
  };

  const onChooseSubscription = (
    paymentPlanId?: number,
    modifierId?: string,
  ) => {
    if (modifierId === "custom") {
      analytics().sendEvent(
        `landing_${AnalyticsEvents.iban_subscription_premium_custom}`,
      );
      openModal();
      return;
    }

    analytics().sendEvent(
      `landing_${AnalyticsEvents.iban_subscription_}${paymentPlanId}`,
    );
    navigate(routes.subscription);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setVisibleTab(newValue);
  };

  return (
    <Container sx={{ mt: 10, mb: 10 }}>
      <Box textAlign="center">
        <Typography variant="h2" sx={{ mb: 2.5 }}>
          Оберіть оптимальний тариф для себе
        </Typography>
        <Typography variant="h5" color="grey800" sx={{ mb: 4 }}>
          Спробуйте безкоштовно або заощаджуйте із річним тарифом
        </Typography>
      </Box>
      <Box sx={styles.tabWrapper}>
        <Tabs value={visibleTab} onChange={handleTabChange} variant="fullWidth">
          {subscriptionTabs.map((tab) => (
            <Tab
              sx={{ "&.Mui-selected": { color: "grey900" } }}
              key={tab.id}
              value={tab.id}
              label={tab.label}
            />
          ))}
        </Tabs>
        <Chip label="-16%" sx={styles.tabChip} />
      </Box>

      {subscriptionTabs.map((tab) => (
        <TabPanel key={`panel-${tab.id}`} value={visibleTab} index={tab.id}>
          <Box sx={styles.tabPanelWrapper}>
            {tab.subscriptions.map((subscription) => (
              <SubscriptionItem
                key={subscription.id}
                card={subscription}
                onChooseSubscription={onChooseSubscription}
                period={tab.period}
                customBtnText={"Отримати пропозицію"}
              />
            ))}
          </Box>
        </TabPanel>
      ))}

      <PageBanner
        overline="Індивідуальний тариф"
        title="Не знайшли ідеального тарифу?"
        subtitle="Розкажіть, що вам потрібно, і ми підберемо найкраще рішення для вас."
        img={HomeBunnerImg}
        actionButtonText="Отримати пропозицію"
        onActionsButtonClick={openModal}
      />

      <WorkInProgressModal
        source="Індивідуальний тариф"
        title="Індивідуальний тариф"
        description="Залиште свій номер, і ми зв’яжемося з вами для обговорення деталей."
        isOpen={isContactModalOpen}
        closeModal={closeModal}
      />
    </Container>
  );
};

const styles = {
  tabWrapper: {
    ml: "auto",
    mr: "auto",
    mb: 3,
    maxWidth: "248px",
    position: "relative",
  },
  tabChip: {
    position: "absolute",
    top: -13,
    right: -25,
    borderRadius: 2,
    height: 26,
    "& .MuiChip-label": {
      padding: "2px 8px",
    },
    backgroundColor: "#3FA93A",
    color: "#FFFFFF",
  },
  tabPanelWrapper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    "@media (min-width: 1100px)": {
      alignItems: "stretch",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    gap: 2,
    mb: 15,
  },
};

export default Subscriptions;
